/* Atelier takı ürün sayfası — kargo saati, hediye merdiveni, müşteri sesi, sabit satın alma çubuğu.
   Sepet ve varyant akışı temanın kendi bileşenlerine bırakılır; bu dosya sepeti değiştirmez. */
(() => {
  const money = (cents) => {
    const c = Math.max(0, Number(cents) || 0);
    const hasCents = c % 100 !== 0;
    return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: hasCents ? 2 : 0 }).format(c / 100) + ' TL';
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) Türkiye saatiyle 14.00 öncesi aynı gün kargoda ve ertesi gün teslim; sonrası ertesi sabah kargoda. */
  if (!customElements.get('atelier-dispatch')) {
    customElements.define('atelier-dispatch', class extends HTMLElement {
      connectedCallback() {
        this.update();
        this.timer = setInterval(() => this.update(), 30000);
        this.onVisible = () => { if (!document.hidden) this.update(); };
        document.addEventListener('visibilitychange', this.onVisible);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisible);
      }
      update() {
        const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
        const hour = Number(parts.find((p) => p.type === 'hour').value);
        const minute = Number(parts.find((p) => p.type === 'minute').value);
        const cutoff = Number(this.dataset.cutoff || 14);
        const title = this.querySelector('[data-dispatch-title]');
        const sub = this.querySelector('[data-dispatch-sub]');
        if (hour < cutoff) {
          const left = (cutoff - hour) * 60 - minute;
          const h = Math.floor(left / 60), m = left % 60;
          const span = (h ? h + ' sa ' : '') + m + ' dk';
          title.textContent = 'Bugün kargoya verilir';
          sub.textContent = 'Türkiye içi: ' + span + ' içinde sipariş verirseniz Türkiye saatiyle 14.00’e kadar kargoda, ertesi gün kapınızda olur.';
          this.dataset.day = 'today';
        } else {
          title.textContent = 'Yarın sabah kargoya verilir';
          sub.textContent = 'Türkiye içi: Türkiye saatiyle 14.00’ten sonra verilen siparişler ertesi sabah kargoya verilir.';
          this.dataset.day = 'tomorrow';
        }
      }
    });
  }

  /* 2) Hediye merdiveni: mevcut hediye kontrolcüsünün verisini okur, sepete dokunmaz. */
  if (!customElements.get('atelier-gifts')) {
    let latest = null;
    customElements.define('atelier-gifts', class extends HTMLElement {
      connectedCallback() {
        this.onState = (e) => { latest = e.detail; this.render(); };
        document.addEventListener('luna-gifts:state', this.onState);
        this.render();
      }
      disconnectedCallback() { document.removeEventListener('luna-gifts:state', this.onState); }
      source() {
        const cards = [...document.querySelectorAll('[data-luna-gift-state]')];
        return cards.find((c) => c.dataset.lunaGiftContext === 'product') || cards[0] || null;
      }
      config() {
        const card = this.source();
        const d = card ? card.dataset : {};
        const base = {
          eligibleCents: Number(d.lunaEligibleTotal || 0),
          flowerThreshold: Number(d.lunaAtmaThreshold || 350000),
          veilThreshold: Number(d.lunaVeilThreshold || 600000),
          flowerAvailable: d.lunaAtmaAvailable === 'true',
          veilAvailable: d.lunaVeilAvailable === 'true',
          flowerImage: d.lunaAtmaImage || '',
          veilImage: d.lunaVeilImage || ''
        };
        return latest && latest.config ? Object.assign(base, latest.config) : (card ? base : null);
      }
      render() {
        const cfg = this.config();
        if (!cfg || !cfg.flowerAvailable) { this.hidden = true; return; }
        const price = Number(this.dataset.price) || 0;
        const current = Number(cfg.eligibleCents) || 0;
        const projected = current + price;
        const veil = Boolean(cfg.veilAvailable);
        const max = veil ? cfg.veilThreshold : cfg.flowerThreshold;
        const flowerAt = Math.min(100, (cfg.flowerThreshold / max) * 100);
        const fill = Math.min(100, (projected / max) * 100);
        const $ = (s) => this.querySelector(s);

        let title, sub;
        if (veil && projected >= cfg.veilThreshold) {
          title = 'Bu setle iki hediye sizin';
          sub = 'Atma çiçeği ve kristal işlemeli duvak sepete ücretsiz eklenir.';
          this.dataset.state = 'veil';
        } else if (projected >= cfg.flowerThreshold) {
          title = 'Bu setle atma çiçeği hediye';
          sub = veil ? 'Duvak hediyesine yalnızca ' + money(cfg.veilThreshold - projected) + ' kaldı.' : 'Hediye sepete ücretsiz eklenir.';
          this.dataset.state = 'flower';
        } else {
          title = 'Atma çiçeği hediyesine ' + money(cfg.flowerThreshold - projected) + ' kaldı';
          sub = current > 0 ? 'Sepetinizdeki ürünler ve bu setle birlikte hesaplandı.' : 'Bu seti ekledikten sonra kalan tutar.';
          this.dataset.state = 'none';
        }
        $('[data-gifts-title]').textContent = title;
        $('[data-gifts-sub]').textContent = sub;
        $('[data-gifts-fill]').style.width = fill + '%';

        const fStop = $('[data-gifts-stop="flower"]'), vStop = $('[data-gifts-stop="veil"]');
        fStop.style.left = flowerAt + '%';
        fStop.classList.toggle('is-reached', projected >= cfg.flowerThreshold);
        vStop.hidden = !veil;
        vStop.classList.toggle('is-reached', veil && projected >= cfg.veilThreshold);

        const fLegend = $('[data-gifts-legend="flower"]'), vLegend = $('[data-gifts-legend="veil"]');
        fLegend.textContent = money(cfg.flowerThreshold);
        fLegend.style.setProperty('--at', flowerAt + '%');
        vLegend.textContent = veil ? money(cfg.veilThreshold) : '';
        vLegend.hidden = !veil;
        $('[data-gifts-terms]').textContent = money(cfg.flowerThreshold) + ' ve üzeri: 1 atma çiçeği.' + (veil ? ' ' + money(cfg.veilThreshold) + ' ve üzeri: atma çiçeği ve Düz Tül Kristal İşlemeli Gelin Duvağı.' : '');
        this.hidden = false;
      }
    });
  }

  /* 3) Müşteri sesi: yumuşak geçişli dönen yorumlar; ekranda değilken ve fare üzerindeyken durur. */
  if (!customElements.get('atelier-voices')) {
    customElements.define('atelier-voices', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-voice]')];
        this.dots = [...this.querySelectorAll('.atl-voices__dots i')];
        this.index = Math.max(0, this.items.findIndex((i) => i.classList.contains('is-active')));
        if (this.items.length < 2) return;
        this.querySelector('[data-voices-next]')?.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.visible ? this.start() : this.stop(); });
        this.io.observe(this);
      }
      disconnectedCallback() { this.stop(); this.io?.disconnect(); }
      go(n) {
        this.index = (n + this.items.length) % this.items.length;
        this.items.forEach((el, i) => { el.classList.toggle('is-active', i === this.index); el.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'); });
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.index));
      }
      start() { if (reduceMotion || !this.visible || this.timer) return; this.timer = setInterval(() => this.go(this.index + 1), 4200); }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() { this.stop(); this.start(); }
    });
  }

  /* 4) Sabit satın alma çubuğu: ana "Sepete ekle" görünmez olunca belirir; temanın ürün formunu gönderir. */
  if (!customElements.get('atelier-sticky')) {
    customElements.define('atelier-sticky', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('[data-sticky-add]');
        this.price = this.querySelector('[data-sticky-price]');
        this.btn?.addEventListener('click', () => this.add());
        this.observe();
        document.addEventListener('variant:change', (e) => {
          const variant = e.detail && e.detail.variant;
          if (variant) {
            this.price.textContent = money(variant.price);
            this.btn.disabled = !variant.available;
            this.btn.querySelector('span').textContent = variant.available ? 'Sepete ekle' : 'Tükendi';
          }
          requestAnimationFrame(() => this.observe());
        });
        this.ro = new ResizeObserver(() => document.documentElement.style.setProperty('--atl-sticky-h', this.getBoundingClientRect().height + 'px'));
        this.ro.observe(this);
      }
      form() { return document.querySelector('.shopify-section--main-product form[id^="product-form-main-"]'); }
      observe() {
        this.target = document.querySelector('.shopify-section--main-product .product-info [data-block-type="buy-buttons"]');
        if (!this.onScroll) {
          let queued = false;
          this.onScroll = () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(() => { queued = false; this.sync(); });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
        }
        this.sync();
      }
      sync() {
        if (document.body.dataset.bayrakDockReady === 'true' && matchMedia('(max-width: 749px)').matches) {
          this.classList.remove('is-visible');
          this.setAttribute('aria-hidden', 'true');
          if (this.btn) this.btn.tabIndex = -1;
          document.documentElement.classList.remove('atl-sticky-on');
          return;
        }
        if (!this.target || !this.target.isConnected) this.target = document.querySelector('.shopify-section--main-product .product-info [data-block-type="buy-buttons"]');
        if (!this.target) return;
        const show = this.target.getBoundingClientRect().bottom < 0;
        if (show === this.classList.contains('is-visible')) return;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.btn.tabIndex = show ? 0 : -1;
        document.documentElement.classList.toggle('atl-sticky-on', show);
      }
      add() {
        const form = this.form();
        if (!form) return;
        const submit = form.querySelector('[type="submit"]');
        if (submit && submit.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit || undefined);
        else submit?.click();
      }
    });
  }

  /* 5) Sayfadaki kart fiyatlarını Türkçe biçime getirir (3,320.00TL → 3.320 TL). Tutar Shopify'ındır. */
  (() => {
    const main = document.querySelector('main') || document.body;
    const rx = /^(\d{1,3}(?:,\d{3})*)(?:\.(\d{2}))?\s?TL$/;
    const format = () => {
      main.querySelectorAll('sale-price, compare-at-price, .price-list span, .ccv2-price span').forEach((el) => {
        const node = [...el.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
        if (!node) return;
        const m = node.textContent.trim().match(rx);
        if (!m) return;
        const whole = m[1].replace(/,/g, '.');
        node.textContent = whole + (m[2] && m[2] !== '00' ? ',' + m[2] : '') + '\u00a0TL';
      });
      /* Metal renkleri: seçenek adına göre gerçekçi metal dokusu (Gold, Gümüş/Silver, Rose). */
      main.querySelectorAll('.variant-picker .block-swatch, .variant-picker .color-swatch').forEach((el) => {
        const dot = el.classList.contains('color-swatch') ? el : el.querySelector('.block-swatch__color');
        if (!dot || dot.dataset.metal) return;
        const t = el.textContent.trim().toLocaleLowerCase('tr-TR');
        const metal = /gold|altın/.test(t) ? 'gold' : /gümüş|gumus|silver|rodyum/.test(t) ? 'silver' : /rose/.test(t) ? 'rose' : /bronz/.test(t) ? 'bronze' : /janjan/.test(t) ? 'aurora' : '';
        if (metal) dot.dataset.metal = metal;
      });
    };
    format();
    let queued = false;
    new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; format(); }); })
      .observe(main, { childList: true, subtree: true });
  })();

  /* 6) Kampanya geri sayımı: bitişte kartı gizler. */
  if (!customElements.get('atelier-countdown')) {
    customElements.define('atelier-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.out = this.querySelector('[data-countdown]');
        if (!Number.isFinite(this.end)) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const left = Math.floor((this.end - Date.now()) / 1000);
        if (left <= 0) {
          clearInterval(this.timer);
          const card = this.closest('[data-atl-offer]');
          if (card) card.hidden = true;
          return;
        }
        const d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
        const pad = (n) => String(n).padStart(2, '0');
        this.out.textContent = (d ? d + ' gün ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      }
    });
  }

  /* 7) Sekmeler (Görünümü tamamlayın). */
  if (!customElements.get('atelier-tabs')) {
    customElements.define('atelier-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
      }
      select(tab) {
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          const panel = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }
})();
